/**
 * Перечисления платформы «ПромТурТверь».
 *
 * Источник истины — ТЗ PT-2026: §1.5 (термины), §6.4 (модель данных), §7.2 (контракты),
 * Приложение В (матрица прав). Значения enum'ов используются в БД, API и UI без расхождений.
 */
/** Мессенджер-источник сессии. Один пользователь может быть заведён в обоих. */
export var Messenger;
(function (Messenger) {
    Messenger["Telegram"] = "telegram";
    Messenger["Max"] = "max";
})(Messenger || (Messenger = {}));
/**
 * Роли (ТЗ §3.1, Приложение В).
 * guest            — посетитель, автоматически при первом открытии Mini App;
 * object_moderator — представитель предприятия, доступ только к своему объекту;
 * region_admin     — сотрудник Министерства туризма, сквозная аналитика и модерация;
 * platform_operator— сотрудник исполнителя, справочники, промо, мониторинг.
 */
export var UserRole;
(function (UserRole) {
    UserRole["Guest"] = "guest";
    UserRole["ObjectModerator"] = "object_moderator";
    UserRole["RegionAdmin"] = "region_admin";
    UserRole["PlatformOperator"] = "platform_operator";
})(UserRole || (UserRole = {}));
/** Статус брони. FR-BOOK-04, FR-NF-05. */
export var BookingStatus;
(function (BookingStatus) {
    /** Создана, ожидает оплаты (платный слот) — в MVP допускается оплата на месте. */
    BookingStatus["PendingPayment"] = "pending_payment";
    /** Подтверждена, места закреплены, пропуск выпущен. */
    BookingStatus["Confirmed"] = "confirmed";
    BookingStatus["Cancelled"] = "cancelled";
    /** Визит состоялся (чек-ин подтверждён). */
    BookingStatus["Completed"] = "completed";
})(BookingStatus || (BookingStatus = {}));
/** Тип билета. FR-BOOK-02: правило и размер скидки задаёт предприятие. */
export var TicketType;
(function (TicketType) {
    TicketType["Individual"] = "individual";
    TicketType["Group"] = "group";
    TicketType["Discounted"] = "discounted";
})(TicketType || (TicketType = {}));
/** Статус слота. FR-MGR-02. */
export var SlotStatus;
(function (SlotStatus) {
    SlotStatus["Open"] = "open";
    SlotStatus["Closed"] = "closed";
    SlotStatus["Cancelled"] = "cancelled";
})(SlotStatus || (SlotStatus = {}));
/** Статус карточки предприятия. FR-ADM-02. */
export var EnterpriseStatus;
(function (EnterpriseStatus) {
    EnterpriseStatus["Draft"] = "draft";
    /** Отправлено на модерацию администратору региона. */
    EnterpriseStatus["OnReview"] = "on_review";
    EnterpriseStatus["Published"] = "published";
    EnterpriseStatus["Rejected"] = "rejected";
    EnterpriseStatus["Archived"] = "archived";
})(EnterpriseStatus || (EnterpriseStatus = {}));
/** Статус программы экскурсии. FR-MGR-05. */
export var ExcursionStatus;
(function (ExcursionStatus) {
    ExcursionStatus["Draft"] = "draft";
    ExcursionStatus["Published"] = "published";
    ExcursionStatus["Archived"] = "archived";
})(ExcursionStatus || (ExcursionStatus = {}));
/** Источник чек-ина. FR-LOY-01. */
export var CheckinSource;
(function (CheckinSource) {
    CheckinSource["Qr"] = "qr";
    CheckinSource["Manual"] = "manual";
})(CheckinSource || (CheckinSource = {}));
/** Канал уведомления. FR-NTF-01. */
export var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["MessengerPush"] = "messenger_push";
    NotificationChannel["Email"] = "email";
    NotificationChannel["BotMessage"] = "bot_message";
})(NotificationChannel || (NotificationChannel = {}));
/** Статус уведомления. */
export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["Pending"] = "pending";
    NotificationStatus["Scheduled"] = "scheduled";
    NotificationStatus["Sent"] = "sent";
    NotificationStatus["Failed"] = "failed";
    NotificationStatus["Cancelled"] = "cancelled";
})(NotificationStatus || (NotificationStatus = {}));
/** Тип скидки. FR-LOY-04. */
export var DiscountKind;
(function (DiscountKind) {
    DiscountKind["Percent"] = "percent";
    DiscountKind["Fixed"] = "fixed";
})(DiscountKind || (DiscountKind = {}));
/** Вид B2B-заявки. FR-B2B-01, FR-B2B-03. */
export var B2BRequestKind;
(function (B2BRequestKind) {
    /** Заявка на подключение предприятия к платформе. */
    B2BRequestKind["Onboarding"] = "onboarding";
    /** Заявка на деловой визит: техническая экскурсия, переговоры, поиск поставщика. */
    B2BRequestKind["BusinessVisit"] = "business_visit";
})(B2BRequestKind || (B2BRequestKind = {}));
/** Статус B2B-заявки. FR-B2B-02: срок ответа — не более двух рабочих дней. */
export var B2BRequestStatus;
(function (B2BRequestStatus) {
    B2BRequestStatus["New"] = "new";
    B2BRequestStatus["InProgress"] = "in_progress";
    B2BRequestStatus["Answered"] = "answered";
    B2BRequestStatus["Rejected"] = "rejected";
})(B2BRequestStatus || (B2BRequestStatus = {}));
/** Категория производства (справочник, FR-DASH-02). */
export var ProductionCategory;
(function (ProductionCategory) {
    ProductionCategory["MachineBuilding"] = "machine_building";
    ProductionCategory["FolkCrafts"] = "folk_crafts";
    ProductionCategory["FoodIndustry"] = "food_industry";
    ProductionCategory["ItAndInnovation"] = "it_and_innovation";
    ProductionCategory["Energy"] = "energy";
    ProductionCategory["ChemicalIndustry"] = "chemical_industry";
    ProductionCategory["Other"] = "other";
})(ProductionCategory || (ProductionCategory = {}));
//# sourceMappingURL=enums.js.map